<template>
  <div>
    <ModuleHeader>Reporte de salidas por insumo</ModuleHeader>
    <v-overlay v-if="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col cols="12" md="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="6" cols="12">
                <label>Fecha inicial</label>
                <Datepicker
                  :input-class="'v-input__control theme--light v-text-field dateinputClass pa-1'"
                  @selected="(date) => selectDate(date, 1)"
                  @input="getAperturas()"
                  :value="input_date.format('YYYY/MM/DD')"
                ></Datepicker>
              </v-col>
              <v-col md="6" cols="12">
                <label>Fecha final</label>
                <Datepicker
                  :input-class="'v-input__control theme--light v-text-field dateinputClass pa-1'"
                  @selected="(date) => selectDateFinal(date, 1)"
                  @input="getAperturas()"
                  :disabled-dates="disableDates"
                  :value="input_date_final.format('YYYY/MM/DD')"
                ></Datepicker>
              </v-col>
              <v-col md="5" cols="12">
                <v-autocomplete
                  label="Departamentos"
                  @input="getAperturas()"
                  v-model="selectDep"
                  item-text="Nombre"
                  item-value="id"
                  :items="departamentos"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  label="Turno"
                  v-model="selectTurno"
                  item-value="Turno"
                  item-text="Desc"
                  :items="turnosList"
                >
                  <template v-slot:append-outer>
                    <v-btn @click="getAperturas()" small color="primary"
                      >Buscar turnos</v-btn
                    >
                  </template>
                </v-autocomplete>
              </v-col>

              <!-- <v-col md="3" cols="12">
                <v-autocomplete
                  label="Meseros"
                  v-model="selectMesero"
                  item-text="Nombre"
                  item-value="id"
                  :items="meserosComp"
                ></v-autocomplete>
              </v-col> -->
              <v-col class="text-right align-content-center" cols="12" md="1">
                <v-btn block depressed @click="searchVentas()" color="success">
                  Buscar
                </v-btn>
              </v-col>
              <v-col cols="12" md="8"
                ><v-text-field
                  label="Filtrar resultados"
                  v-model="filter"
                ></v-text-field
              ></v-col>
              <v-col cols="12" md="4" class="text-end pt-n0">
                <v-btn @click="exportExcel()" color="green" dark class="mx-2"
                  >Exportar excel</v-btn
                >
                <v-btn @click="generatePdf()" color="red" dark
                  >Generar PDF</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-simple-table dense v-if="insumosPorVenta.length > 0">
      <thead class="text-left">
        <th>Insumo o Insumo Compuesto</th>
        <th>Cantidad total</th>
        <th class="text-left">Ventas</th>
        <!-- <th>Costo total (mxn)</th> -->
      </thead>
      <tbody>
        <tr v-for="insumo in filteredInsumos" :key="insumo.id">
          <td>
            <div>
              <b> {{ insumo.Nombre }} </b><br />
              Categoría: {{ insumo.nombreCategoria }}
              <div class="text-caption">
                <p class="mb-0">
                  Tipo: <b>{{ insumo.tipo }}</b> Id: {{ insumo.Id }}
                </p>
              </div>
            </div>
          </td>
          <td>
            {{ $pgsHelper.formatNumber(insumo.TotalCantidad) }} {{ insumo.UM }}
          </td>
          <td class="text-left">
            <v-btn
              @click="openDetail(insumo.insumoVentas)"
              small
              color="success"
              >Detalle</v-btn
            >
          </td>
          <!-- <td>{{ $pgsHelper.formatNumber(insumo.TotalCosto) }}</td> -->
        </tr>
      </tbody>
    </v-simple-table>
    <v-container v-else>
      Busque las ventas por insumo entre las fechas.
    </v-container>
    <v-dialog
      v-model="detailModal"
      transition="dialog-bottom-transition"
      max-width="800"
    >
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-btn icon dark @click="detailModal = false" aria-label="Cerrar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Ventas del insumo</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <!-- Aquí va la tabla en lugar del v-list -->
        <v-card-text>
          <v-simple-table dense>
            <thead class="text-left">
              <tr>
                <th>Folio</th>
                <th>Cantidad</th>
                <th>Unidad</th>
                <th>Producto</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="venta in ventasPorInsumo"
                :key="venta.folio + '-' + venta.producto"
                :class="venta.isGrey ? 'grey-row' : ''"
              >
                <td>{{ venta.folio }}</td>
                <td>{{ venta.cantidad }}</td>
                <td>{{ venta.UM }}</td>
                <td>
                  {{ venta.producto }}
                  <v-chip
                    v-if="venta.isModificador"
                    color="amber darken-3"
                    text-color="white"
                    x-small
                    class="ml-2"
                  >
                    Modi: {{ venta.nombreModificador }}
                  </v-chip>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="detailModal = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import GenericExcelExporter from "../../clases/ExcelMaker/GeneralExcel";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import VentasInsumo from "../../clases/PdfMakers/ReporteVentasInsumo";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "VentasInsumo",
  components: { Datepicker },
  data() {
    return {
      Categories: [],
      insumosPorVenta: [],
      input_date: moment(),
      input_date_final: moment(),
      selectDep: "ALL",
      selectTurno: "ALL",
      selectClient: "",
      input_folio: "",
      loadingData: false,
      detailModal: false,
      aperturas: [],
      ventasPorInsumo: [],
      filter: "",
    };
  },
  methods: {
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    exportExcel() {
      const excelData = this.insumosPorVenta.map((ins) => {
        const { insumoVentas, ...insumo } = ins;
        const ventasDeInsumo = insumoVentas
          .map(
            ({
              folio,
              cantidad,
              UM,
              producto,
              isModificador,
              nombreModificador,
            }) => {
              let prodText = producto.toString().trim();
              if (isModificador) prodText += ` (Modi: ${nombreModificador})`;
              return `${folio} (${cantidad} ${UM}) - ${prodText}`;
            },
          )
          .join(", ");

        return {
          ...insumo,
          ventasDeInsumo,
        };
      });
      // console.log(excelData);
      const options = {
        json_fields: {
          Id: "Id",
          Categoría: "Categoria",
          "Nombre de Categoría": "nombreCategoria",
          Nombre: "Nombre",
          "Cantidad total": "TotalCantidad",
          UM: "UM",
          Tipo: "tipo",
          "Ventas del Insumo": "ventasDeInsumo",
        },
      };
      GenericExcelExporter.generateExcelBuffer(excelData, options)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "VentasPorInsumo.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error exportando:", error));
    },
    async generatePdf() {
      const mainData = {
        TITLE: "Ventas de Insumo",
        FF: this.input_date.format("YYYY-MM-DD"),
        FU: this.input_date_final.format("YYYY-MM-DD"),
        FG: moment().format("DD/MM/YYYY"),
        HG: moment().format("HH:mm:ss"),
        data: this.insumosPorVenta,
      };

      const docData = VentasInsumo.getDocData(mainData);
      //   console.log("docData", docData);
      pdfmake.createPdf(docData).open();
    },
    openDetail(insumoVentas) {
      let lastFolio = null;
      let grey = false;
      this.ventasPorInsumo = insumoVentas.map((v) => {
        if (v.folio !== lastFolio) {
          grey = !grey;
          lastFolio = v.folio;
        }
        return { ...v, isGrey: grey };
      });
      this.detailModal = true;
    },
    async searchVentas() {
      try {
        this.loadingData = true;
        const ventas = await this.getVentas();
        await this.$nextTick();
        this.insumosPorVenta = this.processVentas(ventas);
      } finally {
        this.loadingData = false;
        // console.log("insumosPorVenta:", this.insumosPorVenta);
      }
    },
    async getVentas() {
      const turnos =
        this.selectTurno === "ALL"
          ? this.aperturas.map((a) => a.Turno)
          : [this.selectTurno];
      if (turnos.length === 0) {
        console.error("no turnos");
        return [];
      }
      // busqueda de 30 en 30
      const chunkSize = 30;
      const chunks = [];
      for (let i = 0; i < turnos.length; i += chunkSize) {
        chunks.push(turnos.slice(i, i + chunkSize));
      }
      // filtros
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final
        .clone()
        .add(1, "day")
        .format("YYYY-MM-DD");
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const baseFilters = [
        firestore.where("FechaVenta", ">=", startDate),
        firestore.where("FechaVenta", "<", endDate),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant,
        ),
      ];
      if (this.selectDep !== "ALL") {
        baseFilters.push(firestore.where("Departamento", "==", this.selectDep));
      }
      if (this.selectClient) {
        baseFilters.push(
          firestore.where("Cliente.Id", "==", this.selectClient),
        );
      }
      if (this.input_folio) {
        baseFilters.push(firestore.where("Folio", "==", this.input_folio));
      }

      // ejecutar queries
      const promises = chunks.map((chunk) =>
        firestore.queryBuilder("PDV_Ventas", [
          ...baseFilters,
          firestore.where("Turno", "in", chunk),
        ]),
      );
      const snapshots = await Promise.all(promises);

      // extraer datos
      let allDocs = [];
      snapshots.forEach((snap) => {
        allDocs.push(
          ...snap.docs.map((doc) => ({
            id: doc.ref.id,
            ...doc.data(),
            fecha: moment(doc.data().FechaCreacion).format("YYYY-MM-DD HH:mm"),
          })),
        );
      });

      // ordenar
      const ordered = this.$_.orderBy(allDocs, "fecha", "desc");
      return ordered;
    },
    traverseCatalogo(items, insumos) {
      (items || []).forEach((item) => {
        if (item.Tipo === "AYB-Insumo" || item.Tipo === "AYB-ICompuesto") {
          let prod = null;
          if (item.Id) {
            prod = this.$pgsHelper.getById(this.global_prod, "id", item.Id);
          }
          insumos.push({ ...item, Categoria: prod?.Categoria });
        } else if (
          item.Tipo === "AYB-Producto" &&
          Array.isArray(item.Catalogo)
        ) {
          this.traverseCatalogo(item.Catalogo, insumos);
        }
      });
    },
    extractInsumos(catalogo) {
      const insumos = [];
      this.traverseCatalogo(catalogo, insumos);
      return insumos;
    },
    extractInsumosDeModificadores(producto, allProductsMap, cantidadProd = 1) {
      if (!producto.Modificadores) return [];

      const modificadores = Array.isArray(producto.Modificadores)
        ? producto.Modificadores
        : Object.values(producto.Modificadores);

      return modificadores.flatMap((modi) =>
        (modi.sel || []).flatMap((sel) => {
          const refProduct = sel.ref?.id
            ? allProductsMap.get(sel.ref.id)
            : null;
          if (!refProduct) return [];

          const totalCnt = Number(sel.Cnt || 1) * Number(sel.ref?.cnt || 1) * cantidadProd;
          const modiName = sel.nam || refProduct.Nombre || "Modificador";

          // console.log(
          //   "Modificador detectado:",
          //   modiName,
          //   "| Producto Ref:",
          //   refProduct.Nombre,
          //   "| Cant:",
          //   totalCnt,
          // );

          if (["AYB-Insumo", "AYB-ICompuesto"].includes(refProduct.Tipo)) {
            return [
              {
                Id: sel.ref.id,
                Cantidad: totalCnt,
                Tipo: refProduct.Tipo,
                Extra: refProduct.Extra,
                Categoria: refProduct.Categoria,
                NombreModificador: modiName,
              },
            ];
          }

          if (
            refProduct.Tipo === "AYB-Producto" &&
            Array.isArray(refProduct.Catalogo)
          ) {
            return this.extractInsumos(refProduct.Catalogo).map((item) => ({
              ...item,
              Cantidad: item.Cantidad * totalCnt,
              NombreModificador: modiName,
            }));
          }

          return [];
        }),
      );
    },
    processVentas(ventas) {
      const allProducts = this.$store.getters.getProductos || [];
      const allProductsMap = new Map();
      for (const p of allProducts) {
        if (p.id) allProductsMap.set(p.id, p);
        if (p.Id) allProductsMap.set(p.Id, p);
      }

      // extraigo cada insumo con su folio y el nombre del producto raíz o modificador
      const insumosPlanos = ventas.flatMap((venta) => {
        const folio = venta.Folio;
        return venta.Catalogo.flatMap((producto) => {
          const nombreProd = producto.Nombre;
          let cantidadProd = producto.Cnt - (producto.Dto ? producto.Dto : 0);
          if (cantidadProd < 0) cantidadProd = 0;

          // insumos del producto base (receta)
          const insumosBase = this.extractInsumos(producto.Catalogo).map(
            (item) => ({
              ...item,
              Cantidad: item.Cantidad * cantidadProd,
              folio,
              producto: nombreProd,
              isModificador: false,
              nombreModificador: "",
            }),
          );

          // insumos vinculados a los modificadores aplicados
          const insumosModi = this.extractInsumosDeModificadores(
            producto,
            allProductsMap,
            cantidadProd
          ).map((item) => ({
            ...item,
            folio,
            producto: nombreProd,
            isModificador: true,
            nombreModificador: item.NombreModificador,
          }));

          // Retornamos todos los insumos base (sin filtrar) más los de modificadores
          return [...insumosBase, ...insumosModi];

        });
      });

      const allInsumos = this.global_prod;
      const prodMap = new Map(allInsumos.map((p) => [p.id, p.Nombre]));

      // agrupo por Id
      const agrupados = insumosPlanos.reduce((acc, item) => {
        const {
          Id,
          Cantidad,
          Extra,
          folio,
          producto,
          Tipo,
          Categoria,
          isModificador,
          nombreModificador,
        } = item;
        const unidad = Extra?.AYB?.UM || "Pza";
        let categoriaData = this.$pgsHelper.getById(
          this.Categories,
          "id",
          Categoria,
        );
        let nombreCategoria = categoriaData ? categoriaData.Nombre : "";
        const tipo = Tipo == "AYB-ICompuesto" ? "Compuesto" : "Insumo";
        if (!acc[Id]) {
          acc[Id] = {
            Id,
            Categoria,
            nombreCategoria,
            Nombre: prodMap.get(Id) || "—",
            TotalCantidad: Cantidad,
            UM: unidad,
            tipo: tipo,
            insumoVentas: [
              {
                folio,
                cantidad: Cantidad,
                UM: unidad,
                producto,
                isModificador,
                nombreModificador,
              },
            ],
          };
        } else {
          acc[Id].TotalCantidad += Cantidad;

          // si ya hay entry para este folio+producto+modificador, solo sumo cantidad
          const existe = acc[Id].insumoVentas.find(
            (v) =>
              v.folio === folio &&
              v.producto === producto &&
              v.nombreModificador === nombreModificador,
          );

          if (existe) {
            existe.cantidad += Cantidad;
          } else {
            acc[Id].insumoVentas.push({
              folio,
              cantidad: Cantidad,
              UM: unidad,
              producto,
              isModificador,
              nombreModificador,
            });
          }
        }
        return acc;
      }, {});
      // console.log("cont", cont);

      // convierto a array y ordeno por Nombre
      return this.$_.orderBy(Object.values(agrupados), "Nombre", "asc");
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = this.input_date;
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getAperturas() {
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1),
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant,
        ),
        //firestore.where("Caja", "==", this.$route.params.idInstalacion),
        firestore.where("Tipo", "==", "Apertura"),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep),
        );
      }
      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);
      //
      let aperturas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      aperturas.forEach((apt) => {
        let fecha = new moment(apt.Momento, "YYYY-MM-DD_HH:mm:ss");
        let caja = this.$pgsHelper.getById(this.data_cajas, "id", apt.Caja);
        let cajeroData = this.$pgsHelper.getById(
          this.cajeros,
          "Id",
          apt.Cajero,
        );
        apt.CajaData = caja;
        apt.CajeroData = cajeroData;
        apt.CajeroName = "";
        apt.Desc =
          "Turno Fecha " +
          fecha.format("DD-MM-YYYY") +
          " Hora: " +
          fecha.format("HH:mm") +
          " || " +
          caja.Nomb +
          " || Turno: " +
          apt.Turno;
      });

      this.aperturas = aperturas;
    },
    async getCajeros() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros",
        );

      if (snapshot.exists()) {
        this.cajeros = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cajeros.push(toAdd);
          }
        });
      }
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas",
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params?.user?.tokenResult?.claims;
      const cats = this.getCategoriesFiltered(claims);
      this.Categories = [{ id: "GREENFEE", label: "GREEN FEE" }, ...cats];
    },
  },
  computed: {
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
    filteredInsumos() {
      if (!this.filter || this.filter.trim() === "") {
        return this.insumosPorVenta;
      }
      const filtro = this.filter.toLowerCase().trim();
      return this.insumosPorVenta.filter((item) =>
        item.Nombre.toLowerCase().includes(filtro),
      );
    },
    turnosList() {
      let dep = [
        {
          Turno: "ALL",
          Desc: "Todos",
          CajeroName: "Todos",
        },
      ];
      this.aperturas.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    disableDates() {
      return { to: moment(this.input_date).toDate() };
    },
    global_prod() {
      return this.$_.uniqBy(
        this.$store.getters.getProductos.filter(
          (p) => p.Tipo === "AYB-Insumo" || p.Tipo === "AYB-ICompuesto",
        ),
        "id",
      );
    },
  },
  mounted() {
    this.getCajas();
    this.getCajeros();
    this.getAperturas();
    this.getCategories();
  },
};
</script>

<style>
.dateinputClass {
  border: 1px solid gray !important;
  border-radius: 4px !important;
}
.grey-row {
  background-color: #f5f5f5;
}
</style>
